<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('organisations.title')"></page-header-title>

      <v-spacer></v-spacer>

      <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs3>
              <v-autocomplete
                name="organisation.certification_agencies_by"
                v-model="search_params.certified_by"
                :items="certified_by"
                item-text="name"
                item-value="id"
                :label="$t('organisations.certification_agencies_by')"
                autocomplete="new-password"
                @change="filter"
                clearable
              >
              </v-autocomplete>
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                name="organisation.member_of"
                v-model="search_params.member_of"
                :items="members_of"
                item-text="name"
                item-value="id"
                :label="$t('organisations.member_of')"
                autocomplete="new-password"
                @change="filter"
                clearable
              >
              </v-autocomplete>
            </v-flex>
            <v-flex xs3>
              <v-text-field
                :label="$t('global.search')"
                v-model="search_params.any"
                @keydown="checkKeyPress"
                autocomplete="new-password"
              ></v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                name="organisation.selected_customergroups"
                v-model="search_params.customer_group"
                :items="customergroups"
                item-text="name"
                item-value="id"
                :label="$t('organisations.customergroups')"
                autocomplete="new-password"
                @change="filter"
                clearable
              >
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <router-link :to="BACKEND_URL + '/organisations/create'" v-if="$can('organisation-create')">
        <action-button type="new" />
      </router-link>
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="organisations"
            :items-per-page="organisations.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            :must-sort="true"
          >
            <template v-slot:item.owner="{ item }">
              {{ item.owner ? $t("global.yes") : $t("global.no") }}
            </template>

            <template v-slot:item.certification_authority="{ item }">
              {{ item.certification_authority ? $t("global.yes") : $t("global.no") }}
            </template>

            <template v-slot:item.member_organisation="{ item }">
              {{ item.member_organisation ? $t("global.yes") : $t("global.no") }}
            </template>

            <template v-slot:item.customer_groups="{ item }">
              {{ item.customer_groups ? item.customer_groups.map((a) => a.name).join(", ") : "" }}
            </template>

            <template v-slot:item.actions="{ item }">
              <router-link
                :to="{
                  path: BACKEND_URL + '/organisations/edit/' + item.id,
                  props: { id: item.id }
                }"
                v-if="$can('organisation-edit')"
              >
                <action-button type="edit" :icon_only="true" small />
              </router-link>
              <action-button type="delete" @click="del(item.id)" v-if="$can('organisation-delete')" :icon_only="true" small />
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "organisationList",

  data() {
    return {
      url: "",
      organisations: [],
      customergroups: [],
      certified_by: [],
      members_of: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__page_Organisation_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["name"],
        sortDesc: [false]
      },
      search_params: {
        any: "",
        name: "",
        customer_group: ""
      }
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("organisations.name"), value: "name" },
          {
            text: this.$t("organisations.certification_agencies_by"),
            value: "allowed_certification_agencies_name",
            sortable: false
          },
          {
            text: this.$t("organisations.member_of"),
            value: "members_of_name",
            sortable: false
          },
          { text: this.$t("organisations.owner"), value: "owner" },
          {
            text: this.$t("organisations.certification_authority_short"),
            value: "certification_authority"
          },
          {
            text: this.$t("organisations.member_organisation_short"),
            value: "member_organisation"
          },
          {
            text: this.$t("organisations.customergroups"),
            value: "customer_groups",
            sortable: false
          },
          {
            text: this.$t("global.actions"),
            value: "actions",
            width: "20%",
            align: "end",
            sortable: false
          }
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (
            _.has(newVal, "sortBy") &&
            _.has(newVal, "sortDesc") &&
            _.has(oldVal, "sortBy") &&
            _.has(oldVal, "sortDesc") &&
            (!_.isEqual(newVal.sortBy, oldVal.sortBy) || !_.isEqual(newVal.sortDesc, oldVal.sortDesc))
          ) {
            let obj = {
              sortBy: this.pagination.sortBy,
              sortDesc: this.pagination.sortDesc
            }
            localStorage.setItem("__sort_Organisation_List", JSON.stringify(obj))
          }

          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_Organisation_List", newVal.page)
          }

          this.refresh = true
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "organisations"
  },

  created() {
    let lists = [
      {
        key: "certified_by",
        module: "organisations",
        query: "show_all=true&query_certification_authority=1"
      },
      {
        key: "members_of",
        module: "organisations",
        query: "show_all=true&query_member_organisation=1"
      }
    ]

    axios.get(this.API_URL + "organisations?query_certification_authority=1").then((res) => {
      this.certified_by = res.data.data
    })

    axios.get(this.API_URL + "organisations?query_member_organisation=1").then((res) => {
      this.members_of = res.data.data
    })
  },

  methods: {
    list() {
      this.show_loading = true

      let localFilter = localStorage.getItem("__filter_Organisation_List")
      if (localFilter !== null) {
        localFilter = JSON.parse(localFilter)
        this.search_params = localFilter
      }

      let localSort = localStorage.getItem("__sort_Organisation_List")
      if (localSort !== null) {
        localSort = JSON.parse(localSort)
        this.pagination.sortBy = localSort.sortBy
        this.pagination.sortDesc = localSort.sortDesc
      }

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?resourcetype=organisation&" + query).then((res) => {
        this.organisations = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)

        let lists = [
          {
            key: "customergroups",
            module: "customergroups",
            query: "show_all=true"
          }
        ]

        axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
          this.customergroups = res.data.customergroups
        })
      })
    },

    filter(target) {
      this.pagination.page = 1
      this.refresh = true
      localStorage.setItem("__filter_Organisation_List", JSON.stringify(this.search_params))
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "organisation/" + id)
            .then((res) => {
              if (res.data.hasOwnProperty("status") && res.data.status == "has-active-tenants") {
                vm.$awn.warning(vm.$t("organisations.has_active_tenants"))
              } else {
                vm.refresh = true
                vm.$awn.success(vm.$t("global.delete_success"))
              }
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    }
  }
}
</script>

<style scoped></style>
